var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 25",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.158 13.45c.033.683.706.367 1.011.154.29-.203.374-.034.4-.434.016-.263.046-.526.032-.79-.438-.04-.914.066-1.273.33-.185.136-.532.57-.17.74z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f6d2a2",
    stroke: "#000",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#c6b198",
  fillRule: "evenodd",
  d: "M1.158 13.449c.098-.037.202-.063.269-.152z",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 0.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.158 13.449c.098-.037.202-.063.269-.152"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6ad7e5",
  fillRule: "evenodd",
  d: "M2.714 5.32c-2.58-.734-.661-4.057 1.41-2.69zM14.178 2.38c2.042-1.452 3.888 1.825 1.514 2.65z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6d2a2",
  fillRule: "evenodd",
  d: "M14.617 21.849c.52.325 1.467 1.308.69 1.784-.749.693-1.167-.76-1.823-.962.282-.389.64-.743 1.133-.822z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.306 23.633c-.115-.232-.154-.503-.347-.69"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f6d2a2",
  fillRule: "evenodd",
  d: "M5.35 22.96c-.61.095-.952.651-1.46.933-.478.29-.661-.092-.704-.17-.075-.034-.069.033-.185-.085-.443-.709.462-1.226.934-1.578.657-.135 1.068.442 1.414.9z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.186 23.724c.023-.27.235-.451.335-.68"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M2.822 4.403c-.34-.182-.59-.43-.382-.829.193-.369.55-.329.891-.146zM15.155 4.056c.34-.182.59-.43.382-.828-.193-.37-.551-.33-.892-.147z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.498 13.364c-.033.682-.706.366-1.011.153-.29-.202-.374-.034-.4-.434-.017-.263-.046-.525-.032-.79.438-.04.914.066 1.273.33.185.136.532.57.17.74z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f6d2a2",
    stroke: "#000",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#c6b198",
  fillRule: "evenodd",
  d: "M17.498 13.362c-.098-.037-.202-.063-.268-.151z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 0.25,
  d: "M17.498 13.362c-.098-.037-.202-.063-.268-.151"
})), /*#__PURE__*/React.createElement("path", {
  d: "M9.07 1c2.582 0 5.004.374 6.266 2.887 1.133 2.816.73 5.853.903 8.83.149 2.556.478 5.508-.694 7.877-1.231 2.492-4.31 3.118-6.846 3.027-1.992-.073-4.399-.73-5.523-2.573-1.32-2.162-.695-5.377-.599-7.783.114-2.85-.762-5.707.162-8.496C3.7 1.877 6.285 1.223 9.07 1z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6ad7e5",
    stroke: "#000",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.525 4.51c.464 2.73 4.871 2.009 4.238-.744-.567-2.469-4.392-1.785-4.238.745zM4.26 4.952c.6 2.377 4.358 1.768 4.217-.615-.17-2.855-4.792-2.304-4.218.615zM10.057 7.786c.002.355.08.754.014 1.131-.09.171-.265.19-.417.259a.61.61 0 0 1-.469-.37c-.054-.432.02-.849.034-1.28z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.296 5.61a1.046 1.046 0 1 0 0-2.09 1.046 1.046 0 0 0 0 2.09"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.584 5.767a1.046 1.046 0 1 0 0-2.091 1.046 1.046 0 0 0 0 2.091"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M10.613 5.437a1.046 1.046 0 1 0 0-2.091 1.046 1.046 0 0 0 0 2.091"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.896 5.594a1.046 1.046 0 1 0 0-2.091 1.046 1.046 0 0 0 0 2.091"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.244 7.748c-.277.679.154 2.037.905 1.035-.053-.43.02-.848.034-1.279z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.338 6.44c-.516.044-.937.665-.669 1.157.355.65 1.148-.058 1.642.008.569.012 1.035.61 1.491.108.508-.557-.218-1.099-.786-1.341z",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f6d2a2",
    stroke: "#231f20",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }
}), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.274 6.412c-.039-.905 1.666-1.018 1.867-.26.2.755-1.784.931-1.867.26 0 0-.067-.535 0 0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGo);
export default ForwardRef;